/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import TransactionalMessageModel from 'cio/models/transactional-message';
import searchByProperty from 'cio/utils/search-by-property';
import TagModel from 'cio/models/tag';
import { sortByCaseInsensitive } from 'cio/utils/sort';

interface TransactionalMessageListArgs {
  messages: TransactionalMessageModel[];
  searchTerm: string;
  page: number;
  sortBy: keyof TransactionalMessageModel;
  sortDescending: boolean;
  onSetSortDescending: () => unknown;
  onDeleteMessage: () => unknown;
  reloadMessageModel: () => unknown;
  tagIds: string[];
  didChangeTagIds: (tags: string[]) => unknown;
  onPageChange: (page: number) => unknown;
}

const SORT_OPTIONS = [
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Date Created',
    value: 'created',
  },
  {
    label: 'Last Updated',
    value: 'updated',
  },
];

export default class TransactionalMessageList extends Component<TransactionalMessageListArgs> {
  readonly itemsPerPage = 20;
  readonly sortOptions = SORT_OPTIONS;

  get messages() {
    let messages = searchByProperty(this.args.messages, ['name', 'description'], this.args.searchTerm);

    if (this.args.tagIds.length > 0) {
      messages = messages.filter((message) => {
        let ids = message.hasMany('tags').ids();
        return this.args.tagIds.every((id) => ids.includes(id));
      });
    }

    messages = sortByCaseInsensitive(messages, ['isNotDefault', this.args.sortBy]);
    return this.args.sortDescending ? messages.reverse() : messages;
  }

  get totalRecs() {
    let hasDefaultMessage = this.messages.find((m) => m.isDefault);

    if (hasDefaultMessage) {
      // The message list contains a "default" item that consists of all
      // uncategorised messages, so the count is off by one.
      return this.messages.length - 1;
    } else {
      return this.messages.length;
    }
  }

  get pageMessages() {
    let start = (this.args.page - 1) * this.itemsPerPage;
    return this.messages.slice(start, start + this.itemsPerPage);
  }

  @action
  onTagClicked(tag: TagModel) {
    this.args.didChangeTagIds([tag.id]);
  }
}
